const WEEK = 604800000;
const DAY = 86400000;
const today = new Date();

export default {
  getNumericalName(number, variants) {
    const numerals = {
      days: ["день", "дня", "дней"],
      hours: ["час", "часа", "часов"],
      minutes: ["минута", "минуты", "минут"],
      seconds: ["секунда", "секунды", "секунд"],
      rubles: ["рубль", "рубля", "рублей"],
      bug: ["баг", "бага", "багов"],
    };
    if (!Array.isArray(variants)) {
      variants = numerals[variants] || numerals.bug;
    }
    let temp = number;
    while (number >= 10) {
      number = number % 10;
    }
    while (temp >= 100) {
      temp = temp % 10;
    }
    if (number > 0 && number < 5) {
      if (temp > 10 && temp < 15) {
        return variants[2];
      }
      if (number == 1) return variants[0];
      return variants[1];
    }
    return variants[2];
  },
  getNextDate() {
    let next = new Date(2021, 6, 2, 23, 0, 0);
    for (let i = 0; today - next > 0; i++) {
      next = new Date(next.valueOf() + 1 * WEEK);
    }

    return next;
  },
};
